import { React, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateTableActions } from '../../store/update-table-slice';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Edit, Delete } from '@mui/icons-material';
import Progress from '../Progress';
import AddNewAllowanceForm from '../forms/AddNewAllowanceForm';
import EditAllowanceForm from '../forms/EditAllowanceForm';
import Popup from '../Popup';
import Notification from '../Notification';
import ConfirmDialog from '../ConfirmDialog';

let fetch_id = 0;
let delete_id = 0;
export default function CTCconfigurationTable() {
  const [openPopup, setOpenPopup] = useState(false);
  const [allowances, setAllowances] = useState([]);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: '' });
  const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: '', subTitle: '' });
  const [loading, setLoading] = useState(true);

  const dispatch = useDispatch();
  const UPDATE_ALLOWANCES = useSelector(state => state.updateTable.updateAllowances);

  const navigate = useNavigate();
  async function getAllAllowances() {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/configure/ctc-configure/view-allowances`);
      setAllowances(response.data);

    } catch (e) {
      if (e.response.status === 401) {
        setNotify({
          isOpen: true,
          message: 'Session Expired!',
          type: 'error'
        });
        setTimeout(() => {
          navigate('/');
        }, 1000);
      }
    }
    setLoading(false);
  }
  useEffect(() => {
    getAllAllowances();
  }, []);

  useEffect(() => {
    if (UPDATE_ALLOWANCES) {
      getAllAllowances();
      dispatch(updateTableActions.stopUpdateAllowances());
    }
  }, [UPDATE_ALLOWANCES]);

  const handleDelete = async (delete_id) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false
    });
    try {
      const response = await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/configure/ctc-configure/delete-allowance/` + delete_id);
      if (response.status === 200) {
        setNotify({
          isOpen: true,
          message: 'Successfully Deleted!',
          type: 'success'
        });
        dispatch(updateTableActions.startUpdateAllowances());
      }
    } catch (e) {
      if (e.response.status === 422) {
        setNotify({
          isOpen: true,
          message: e.response.data.error_message,
          type: 'error'
        });
        setTimeout(() => {
          navigate('/');
        }, 1000);
      }
      if (e.response.status === 401) {
        setNotify({
          isOpen: true,
          message: 'Session Expired!',
          type: 'error'
        });
        setTimeout(() => {
          navigate('/');
        }, 1000);
      }
    }
  }

  return (
    <>
      {loading ? <Progress /> :
        <div>
          <table style={{ marginLeft: "30px" }} class="table">
            <thead class="table-dark">
              <tr>

                <th scope="col">Allowance</th>
                <th scope="col">Mode</th>
                <th scope="col">Calculated On</th>
                <th scope="col">Criteria</th>
                <th class="table-dark"></th>
                <th class="table-dark"></th>

              </tr>
            </thead>
            <tbody>
            {allowances.map((allowance, i) => {
              const isBasic = allowance?.Allowance?.toLowerCase() === 'basic';
              
              return (
                <tr key={allowance.AllowId}>
                  <td>{allowance?.Allowance}</td>
                  <td>{allowance?.Criteria}</td>
                  <td>{allowance?.calculatedon}</td>
                  <td>
                    {allowance?.Criteria === 'Percent' ? `${allowance?.percents}%` : 'Manual'}
                  </td>
                  <td>
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-sm"
                      onClick={() => {
                        setOpenPopup(true);
                        fetch_id = allowance?.AllowId;
                      }}
                      disabled={isBasic}
                    >
                      <Edit /> Edit
                    </button>
                  </td>
                  <td>
                    <button
                      type="button"
                      className="btn btn-outline-danger btn-sm"
                      onClick={() =>
                        setConfirmDialog({
                          isOpen: true,
                          title: 'Are you sure to delete this record?',
                          subTitle: "You can't undo this operation",
                          onConfirm: () => {
                            handleDelete(allowance?.AllowId);
                          },
                        })
                      }
                      disabled={isBasic}
                    >
                      <Delete /> Delete
                    </button>
                  </td>
                </tr>
              );
            })}
            </tbody>
          </table>
          <Popup
            title="Edit Allowance"
            openPopup={openPopup}
            setOpenPopup={setOpenPopup}
          >
            <AddNewAllowanceForm
              fetch_id={fetch_id}
              setOpenPopup={setOpenPopup}
            />
          </Popup>

        </div>}
      <Notification
        notify={notify}
        setNotify={setNotify} />
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog} />
    </>


  );
}